'use client';

import { cn } from '@core/utils';

import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

import styles from './Hero.module.scss';

export const Hero = () => {
  return (
    <header className="flex w-full flex-col items-center bg-[#FF6F00] py-60">
      <h1 className="sr-only">전국 스탬프 이벤트 - 고향사랑기부</h1>
      <Image
        src={WELLO_IMAGE_PREFIX_URL + '/donation/event/stamp/mois-wello.png'}
        alt="행정안전부와 웰로 로고"
        width={175}
        height={24}
        sizes="175px"
        quality={85}
        priority
        fetchPriority="high"
      />
      <div className="flex flex-col items-center gap-4 pb-60 pt-40">
        <Image
          src={WELLO_IMAGE_PREFIX_URL + '/donation/event/stamp/once.png'}
          alt="딱 한 번"
          width={263}
          height={47}
          sizes="263px"
          quality={85}
          priority
          fetchPriority="high"
        />
        <div className="relative pr-12" aria-hidden="true">
          <Image
            src="/assets/stamp/hero-logo.svg"
            alt="전국 스탬프 투어 로고"
            width={316}
            height={201}
            sizes="316px"
            className={styles.logoAnimation}
            priority
          />
          <div
            className={cn(
              'absolute left-0 top-24',
              styles.floatingImage,
              styles.floatTopLeft,
            )}
          >
            <Image
              src={WELLO_IMAGE_PREFIX_URL + '/donation/event/stamp/hero1.png'}
              alt="장식 이미지 - 떡볶이"
              width={78}
              height={89}
              sizes="78px"
              quality={75}
              loading="lazy"
            />
          </div>
          <div
            className={cn(
              'absolute -right-20 top-32',
              styles.floatingImage,
              styles.floatTopRight,
            )}
          >
            <Image
              src={WELLO_IMAGE_PREFIX_URL + '/donation/event/stamp/hero2.png'}
              alt="장식 이미지 - 김밥"
              width={82}
              height={70}
              sizes="82px"
              quality={75}
              loading="lazy"
            />
          </div>
          <div
            className={cn(
              'absolute -bottom-34 left-48',
              styles.floatingImage,
              styles.floatBottomCenter,
            )}
          >
            <Image
              src={WELLO_IMAGE_PREFIX_URL + '/donation/event/stamp/hero3.png'}
              alt="장식 이미지 - 사과"
              width={57}
              height={57}
              sizes="57px"
              quality={75}
              loading="lazy"
            />
          </div>
          <div
            className={cn(
              'absolute -bottom-50 -right-20',
              styles.floatingImage,
              styles.floatBottomRight,
            )}
          >
            <Image
              src={WELLO_IMAGE_PREFIX_URL + '/donation/event/stamp/hero4.png'}
              alt="장식 이미지 - 곶감"
              width={96}
              height={96}
              sizes="96px"
              quality={75}
              loading="lazy"
            />
          </div>
        </div>
      </div>
      <div className="mt-20 flex flex-col items-center gap-20">
        <p className="text-center font-700 text-Gray-white typo-body1">
          원하는 지역에 기부하면
          <br />
          미션마다 BIG 경품 행운을 드려요~
        </p>
        <p className="font-400 text-Gray-white typo-body2">
          <time dateTime="2025-11-03/2025-11-30">
            이벤트 기간: 11월 3일 ~ 11월 30일 까지
          </time>
        </p>
      </div>
    </header>
  );
};
